<template>
  <div>
    <!-- 图片弹窗正文部分 -->
    <div class="image-modal-mask" v-if="isShow">
      <div class="images">
        <img :src="imageUrl[index]" alt="" />

        <a-icon
          @click="() => (isShow = false)"
          type="close-circle"
          class="close"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    imageUrl: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isShow: false,
      index: 0,
    };
  },

  methods: {
    //   打开弹窗
    openModal() {
      this.isShow = true;
    },
    //   关闭图片弹窗
    closeModal() {
      this.isShow = false;
    },
  },
};
</script>

<style lang="less" scoped>
.image-modal-mask {
  background-color: rgba(0, 0, 0, 0.65);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .images {
    text-align: center;
    position: relative;
    img {
      max-width: 90vw;
      max-height: 90vh;
    }
    .close {
      position: absolute;
      top: -24px;
      right: -24px;
      color: #fff;
      font-size: 28px;
    }
  }
}
</style>